// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import DashboardPlugin from './material-dashboard'
import store from './store'
// router setup
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import router from './routes/router'
//config for keycloak
import config from './config'

import './api'

// plugin setup
Vue.use(DashboardPlugin)
// keycloak setup
Vue.use(VueKeyCloak, {
  config: config.keycloak,
  onReady: () => {
    //create instance app vue when keycloak is ready
    new Vue({
      el: '#app',
      store,
      render: (h) => h(App),
      computed: {
        lang: () => document.documentElement.lang,
      },
      methods: {
        setHotelId(id) {
          if (this.hotelId != id) {
            this.$store.commit('clear')
            this.hotelId = false
            this.$nextTick().then(() => {
              this.hotelId = id
              sessionStorage.setItem('hotel', id)
              localStorage.setItem('hotel', id)
            })
          }
          return true
        },
        hasBackendRole(role) {
          let result
          if (!!Vue.prototype.$keycloak.tokenParsed.resource_access.backend) {
            result = Vue.prototype.$keycloak.tokenParsed.resource_access.backend.roles.find((r) => r === role)
          }

          if (!!Vue.prototype.$keycloak.tokenParsed.resource_access.backend_v2) {
            result = Vue.prototype.$keycloak.tokenParsed.resource_access.backend_v2.roles.find((r) => r === role)
          }
          return !!result ? true : false
        },
        tenantName() {
          return Vue.prototype.$keycloak.tokenParsed['user.groups'][0]
        },
      },
      data() {
        return {
          hotelId: null,
        }
      },
      mounted() {
        this.$on('saved', () => {
          this.$notify({
            timeout: 2500,
            message: 'Saved',
            icon: 'check_box',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success',
          })
        })
        this.$on('wrong-input', () => {
          this.$notify({
            timeout: 2500,
            message: '<strong>Not saved</strong>. Please check your inputs',
            icon: 'check_box',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'danger',
          })
        })
      },
      router,
    })

    //se añade al router el navegation guard
    router.beforeEach((to, from, next) => {
      // router will clear store if api client notified previously
      // to store
      if (store.getters.refresh) store.commit('clear')

      //check page is protected or not
      if (to.meta?.requiereSpecificRole === true) {
        //access roles
        if (to.meta.roleList.some((role) => router.apps[0].$root.hasBackendRole(role))) {
          return next()
        } else {
          router.push({
            name: 'Home',
          })
        }
      } else {
        return next()
      }
    })
  },
})

import moment from 'moment'
Vue.prototype.moment = moment
Vue.config.devtools = true
